import Ajax from '@/lib/ajax'

export default {
  getAllRoles() {
    return Ajax.get(`/api/identity/roles/all`)
  },
  getRoles(pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: 'id desc',
    }
    return Ajax.get(`/api/identity/roles`, {
      params: params,
    })
  },
  getRole(id: any) {
    return Ajax.get(`/api/identity/roles/${id}`)
  },
  postRole(data: any) {
    return Ajax.post(`/api/identity/roles`, data)
  },
  putRole(id: string, data: any) {
    return Ajax.put(`/api/identity/roles/${id}`, data)
  },
  deleteRole(id: string) {
    return Ajax.delete(`/api/identity/roles/${id}`)
  },
}
